<template>
  <div class="page">
    <div class="bosch_logo">
      <div class="header-info1">
        亲爱的客户，您好！感谢您长期以来对博世汽车配件和易加网的支持和关爱。但我们深深感觉到，易加网目前提供的服务与您的需求之间仍有不少差距。由此，我们制作了这份《易加网调查表》，希望聆听您的宝贵意见或建议。所有数据仅用于统计分析，以便我们及时改进，更好地为您服务。谢谢！
      </div>
      <div class="header-info2">
        易加网是博世客户的积分礼品兑换平台：维修站通过易加网扫一扫博世配件上的二维码，可以获得积分，在易加网上兑换礼品。
      </div>
      <!-- <img src="../../assets/images/activity/question2021-bg.png" /> -->
    </div>
    <div class="content">
      <div v-for="(option, index) in optionList" :key="index">
        <div :class="[option.styleType?'box-sp':'box',option.isFooter?'box':'']">
          <div class="bar_title" v-if="!option.styleType||(option.styleType&&option.isTitle)">
            <div class="title-icon">
              <img src="../../../assets/images/header-icon.png"/>
              <span>{{ option.i }}</span>
            </div>
            <div class="title" >
              <span>{{ option.title }}</span>
            </div>

            <div class="questionType" v-show="option.questionType !== '04'&&!option.styleType">{{ typeText(option.questionType,option.isRank) }}</div>
          </div>
          <!-- 单选 -->
          <div v-if="option.questionType === '01'">
            <!-- 单选没有文本框 -->
            <div v-if="!option.starType">
              <van-radio-group v-model="option.index">
                <van-cell-group>
                  <van-cell v-for="(item, i) in option.item" :key="i" :name="i">
                    <van-radio :name="i">{{ item.optionName }}</van-radio>
                  </van-cell>
                </van-cell-group>
              </van-radio-group>
            </div>
            <!-- 单选含有文本框 -->
            <div v-if="option.starType === 'input'">
              <van-radio-group v-model="option.index" @change="option.content = ''">
                <van-cell-group>
                  <van-cell v-for="(item, idx) in option.item"
                      :key="idx"
                      :label="idx">
                    <van-radio :name="idx" >
                      {{ item.optionName }}
                    </van-radio>
                  </van-cell>
                </van-cell-group>
              </van-radio-group>
              <van-cell>
                <van-field v-model="option.content"
                      v-show="option.item && option.index === option.item.length - 1"
                      :placeholder="option.tip"
                      clearable>
                  </van-field>
              </van-cell>
            </div>
          </div>
          <!-- 多选 -->
          <div v-if="option.questionType === '02'">
            <!--排序-->
            <div v-if="option.isRank">
              <van-cell-group>
                <van-cell class="rank"
                  v-for="(item, i) in option.item"
                  :key="i" :name="i"
                  clickable>
                  <span class="optionName">{{item.optionName}}</span>
                  <span class="rank-input">(
                    <van-field v-model="item.value"  @change.native="handleInputChange($event,index,i)"  />
                  )
                     </span>

                </van-cell>
              </van-cell-group>
            </div>

            <div v-if="option.type === 'input'">
              <van-checkbox-group v-model="option.list"  :max="option.max">
                <van-cell-group>
                  <van-cell
                    v-for="(item, i) in option.item"
                    :key="i" :name="i"
                    clickable>
                  <van-checkbox shape="square" :name="i">{{ item.optionName }}</van-checkbox>
                </van-cell>
                </van-cell-group>

                <van-cell>
                  <van-field v-model="option.questionAnswer"
                      v-show="option.item && option.list.indexOf(option.item.length-1)!==-1"
                      :placeholder="option.tip"
                      clearable>
                  </van-field>
                </van-cell>
              </van-checkbox-group>
            </div>

            <div v-if="option.type==='select'">
              <van-checkbox-group v-model="option.list">
              <van-cell-group>
                <van-cell
                  v-for="(item, i) in option.item"
                  :key="i" :name="i"
                  clickable>
                  <van-checkbox shape="square" :name="i">{{ item.optionName }}</van-checkbox>
                </van-cell>
              </van-cell-group>
             </van-checkbox-group>
            </div>
          </div>

          <!-- 问答 -->
          <div v-if="option.questionType === '04'">
            <!--排序-->
          <div v-if="option.isRank" >
              <van-cell-group>
                <van-cell class="rank"
                  v-for="(item, i) in option.item"
                  :key="i" :name="i"
                  clickable>
                  <span class="rank-box" @click="handleRank(option,item)">
                    <span v-show="item.rank">{{item.rank}}</span></span>
                  <span class="optionName">{{item.optionName}}</span>
                </van-cell>
              </van-cell-group>
          </div>

          <div style="padding: 0 10px 10px 10px;" class="score-field">
            <van-field
              v-model="option.questionAdvice"
              type="textarea"
              :placeholder="option.tip"
              autosize
              clearable
            ></van-field>
          </div>
          </div>

          <!-- 评分 -->
          <div v-if="option.questionType === '03'" >

            <div class="item-title"  v-if="option.styleType&&!option.isTitle">
              <span>{{ option.title }}</span>
            </div>

            <!-- 评分星星-->
            <div v-if="option.rateStar" >
              <van-rate v-model="option.rateValue" class="rate-score" />
              <span v-if="option.rateValue > 0" class="rate-evaluation">{{ option.rateTexts[option.rateValue - 1] }}</span>
            </div>

            <!--滑块-->
            <div v-if="option.isSlider" class="slider"  >
              <van-slider  v-model="option.rateValue" :max="10" button-size="18px" @change="onChange" />
              <div class="slider-text">
                <span>完全不可能</span>
                <span>极有可能</span>
              </div>
            </div>

            <div v-if="!option.rateStar&&!option.isSlider">
              <div  class="score-content">
              <div class="score" v-for="(item, i) in option.rateTexts"
              :key="i" :lable="i"
              :class="{select: currentIndex.indexOf(item.rateCode) !== -1}"
              @click="chooseScore(item,i, index)">
                {{ item.text }}
              </div>
              </div>
              <!-- 如果评分低于6分及以下 -->
              <div v-if="option.rateValue > 0 && option.rateValue <= rageScore" class="low-score">
              <!-- 无单选 -->
              <div v-if="!option.item" class="score-field">
                <van-field v-model="option.content" type="textarea" :placeholder="option.contentTitle" autosize clearable></van-field>
              </div>

              <!-- 有输入框 -->
              <div v-if="option.starType === 'input' && option.item">
                <van-radio-group class="van-radio-box" v-model="option.index" @change="option.content = ''">
                  <van-radio class="radio"
                      v-for="(item, i) in option.item"
                      :key="i"
                      :name="i"
                      :label="i">
                    <div class="bg-radio-box">
                      {{ item.optionName }}
                    </div>
                  </van-radio>
                </van-radio-group>
                <van-field v-model="option.content"
                    class="field-input"
                    type="textarea"
                    v-show="option.item && option.index === option.item.length - 1"
                    :placeholder="option.tip"
                    clearable
                    autosize>
                </van-field>
              </div>
              <div class="van-radio-box" v-if="option.starType === 'radio'">
                <!-- 没有输入框的直接显示单选框 -->
                  <van-radio class="radio" v-model="option.index" v-for="(item, i) in option.item" :key="i" :name="i">
                    <div class="bg-radio-box">
                      {{ item.optionName }}
                    </div>
                  </van-radio>
              </div>
              </div>
            </div>

          </div>

        </div>
      </div>
      <div class="submit-btn">
        <van-button :loading="loading" type="info" size="normal" round @click="handleSubmit">提 交</van-button>
      </div>
    </div>

    <!-- 弹窗 -->
    <van-popup v-model="popShow" class="msg-pop" :close-on-click-overlay="false">
      <div class="msg-text">感谢您参与本次问卷</div>
      <div class="msg-text" style="margin-top: 5px;">奖励积分已发放至您的账户</div>
      <div class="msg-btn">
        <van-button class="msg-btn" type="primary" size="large" @click="popJump">返回首页</van-button>
      </div>
    </van-popup>

    <van-popup v-model="popShow2" class="msg-pop msg-pop-join" :close-on-click-overlay="false">
      <div class="msg-text">您已参加过本次问卷调查</div>
      <div class="msg-btn">
        <van-button class="msg-btn" type="primary" size="large" @click="popJump">返回首页</van-button>
      </div>
    </van-popup>
    <!-- 弹窗-不能参加 -->
    <van-popup v-model="popShow3" class="msg-pop msg-pop-error" :close-on-click-overlay="false">
      <div class="msg-text">本活动仅限IAM和OES客户参加</div>
      <div class="msg-btn">
        <van-button class="msg-btn" type="primary" size="large" @click="popJump">返回首页</van-button>
      </div>
    </van-popup>
  </div>
</template>

<script>
import activityApi from '@/api/activity'
import { Toast } from 'vant'
import { userUtils } from '@/utils/auth'
import { commonUtils } from '@/utils/common'
export default {
  name: 'Questionnaire',
  data () {
    return {
      loading: false,
      clientCode: '',
      optionList: [
        {
          title: '您在维修站的职责包括？（可多选）',
          questionCode: '005-01',
          questionType: '02',
          list: [],
          starType: 'input',
          type: 'select',
          i: 1,
          item: [
            { optionCode: '005-01-01', optionName: '维修站老板' },
            { optionCode: '005-01-02', optionName: '技师' },
            { optionCode: '005-01-03', optionName: '采购' },
            { optionCode: '005-01-04', optionName: '库管' },
            { optionCode: '005-01-05', optionName: '前台' }
          ]
        },
        {
          title: '您的维修站每个月产值是多少？',
          questionCode: '005-02',
          questionType: '01',
          index: -1,
          i: 2,
          item: [
            { optionCode: '005-02-01', optionName: '<10万' },
            { optionCode: '005-02-02', optionName: '10~20万' },
            { optionCode: '005-02-03', optionName: '20~40万' },
            { optionCode: '005-02-04', optionName: '40~60万' },
            { optionCode: '005-02-05', optionName: '60万以上' }
          ]
        },
        {
          title: '您的维修站采购博世配件的量占总配件采购量的比例是多少？',
          questionCode: '005-03',
          questionType: '01',
          index: -1,
          i: 3,
          item: [
            { optionCode: '005-03-01', optionName: '<5%' },
            { optionCode: '005-03-02', optionName: '5%~10%' },
            { optionCode: '005-03-03', optionName: '10%~20%' },
            { optionCode: '005-03-04', optionName: '20%~30%' },
            { optionCode: '005-03-05', optionName: '30%以上' }
          ]
        },
        {
          title: '您的维修站使用易加网的频率如何？',
          questionCode: '005-04',
          questionType: '01',
          index: -1,
          i: 4,
          item: [
            { optionCode: '005-04-01', optionName: '不知道易加网是什么' },
            { optionCode: '005-04-02', optionName: '知道什么是易加网，但是很少使用' },
            { optionCode: '005-04-03', optionName: '每月使用几次' },
            { optionCode: '005-04-04', optionName: '每周使用几次' },
            { optionCode: '005-04-05', optionName: '每天都使用' }
          ]
        },
        {
          title: '如果下一代的易加网升级以下功能，您的评价是？（如果不喜欢请说明原因，非常喜欢不能超过5条）',
          questionCode: '005-05',
          i: 5,
          questionType: '03',
          rateValue: 100,
          index: -1,
          content: '',
          styleType: 'sp',
          isTitle: true,
          starType: 'input'
        },
        {
          title: '通过合作平台账号（如：开思、康众等）可以直接注册或者登录易加网',
          questionCode: '005-05-01',
          questionType: '03',
          i: 5,
          rateValue: -1,
          index: -1,
          content: '',
          tip: '请说明不满意的原因',
          starType: 'input',
          selectedOptionCode: '',
          selectedRateCode: '',
          styleType: 'sp',
          rateTexts: [
            { rateCode: '1-1', text: '1分-不喜欢' },
            { rateCode: '1-2', text: '2分-无所谓' },
            { rateCode: '1-3', text: '3分-喜欢' },
            { rateCode: '1-4', text: '4分-非常喜欢' }
          ]
        },
        {
          title: '一个主账号下有老板，技师，库管等不同角色，权限由老板配置',
          questionCode: '005-05-02',
          questionType: '03',
          i: 5,
          rateValue: -1,
          index: -1,
          content: '',
          tip: '请说明不满意的原因',
          starType: 'input',
          selectedOptionCode: '',
          selectedRateCode: '',
          styleType: 'sp',
          rateTexts: [
            { rateCode: '2-1', text: '1分-不喜欢' },
            { rateCode: '2-2', text: '2分-无所谓' },
            { rateCode: '2-3', text: '3分-喜欢' },
            { rateCode: '2-4', text: '4分-非常喜欢' }
          ]
        },
        {
          title: '与其他品牌合作（如：油品、轮胎等），实现积分通兑',
          questionCode: '005-05-03',
          questionType: '03',
          i: 5,
          rateValue: -1,
          index: -1,
          content: '',
          tip: '请说明不满意的原因',
          starType: 'input',
          selectedOptionCode: '',
          selectedRateCode: '',
          styleType: 'sp',
          rateTexts: [
            { rateCode: '3-1', text: '1分-不喜欢' },
            { rateCode: '3-2', text: '2分-无所谓' },
            { rateCode: '3-3', text: '3分-喜欢' },
            { rateCode: '3-4', text: '4分-非常喜欢' }
          ]
        },
        {
          title: '增加抽奖活动：在扫产品上的二维码获得固定易加网积分的基础上，可以抽奖获得更多的积分',
          questionCode: '005-05-04',
          questionType: '03',
          rateValue: -1,
          i: 5,
          index: -1,
          content: '',
          tip: '请说明不满意的原因',
          starType: 'input',
          selectedOptionCode: '',
          selectedRateCode: '',
          styleType: 'sp',
          rateTexts: [
            { rateCode: '4-1', text: '1分-不喜欢' },
            { rateCode: '4-2', text: '2分-无所谓' },
            { rateCode: '4-3', text: '3分-喜欢' },
            { rateCode: '4-4', text: '4分-非常喜欢' }
          ]
        },
        {
          title: '在您常采购的平台上（如：开思、康众等）购买博世配件可以直接获得积分，无需扫码',
          questionCode: '005-05-05',
          questionType: '03',
          rateValue: -1,
          i: 5,
          index: -1,
          content: '',
          tip: '请说明不满意的原因',
          starType: 'input',
          selectedOptionCode: '',
          selectedRateCode: '',
          styleType: 'sp',
          rateTexts: [
            { rateCode: '5-1', text: '1分-不喜欢' },
            { rateCode: '5-2', text: '2分-无所谓' },
            { rateCode: '5-3', text: '3分-喜欢' },
            { rateCode: '5-4', text: '4分-非常喜欢' }
          ]
        },
        {
          title: '礼品商场中上架新礼品',
          questionCode: '005-05-06',
          questionType: '03',
          rateValue: -1,
          i: 5,
          index: -1,
          content: '',
          tip: '请说明不满意的原因',
          starType: 'input',
          selectedOptionCode: '',
          selectedRateCode: '',
          styleType: 'sp',
          rateTexts: [
            { rateCode: '6-1', text: '1分-不喜欢' },
            { rateCode: '6-2', text: '2分-无所谓' },
            { rateCode: '6-3', text: '3分-喜欢' },
            { rateCode: '6-4', text: '4分-非常喜欢' }
          ]
        },
        {
          title: '缩短礼品到货时间',
          questionCode: '005-05-07',
          questionType: '03',
          rateValue: -1,
          i: 5,
          index: -1,
          content: '',
          tip: '请说明不满意的原因',
          starType: 'input',
          selectedOptionCode: '',
          selectedRateCode: '',
          styleType: 'sp',
          rateTexts: [
            { rateCode: '7-1', text: '1分-不喜欢' },
            { rateCode: '7-2', text: '2分-无所谓' },
            { rateCode: '7-3', text: '3分-喜欢' },
            { rateCode: '7-4', text: '4分-非常喜欢' }
          ]
        },
        {
          title: '可以在易加网下载技术资料（如：电路图等）',
          questionCode: '005-05-08',
          questionType: '03',
          rateValue: -1,
          index: -1,
          i: 5,
          content: '',
          tip: '请说明不满意的原因',
          starType: 'input',
          selectedOptionCode: '',
          selectedRateCode: '',
          styleType: 'sp',
          rateTexts: [
            { rateCode: '8-1', text: '1分-不喜欢' },
            { rateCode: '8-2', text: '2分-无所谓' },
            { rateCode: '8-3', text: '3分-喜欢' },
            { rateCode: '8-4', text: '4分-非常喜欢' }
          ]
        },
        {
          title: '通过与指定车型汽修技术专家的视频/语音，获得维修思路的支持',
          questionCode: '005-05-09',
          questionType: '03',
          rateValue: -1,
          i: 5,
          index: -1,
          content: '',
          tip: '请说明不满意的原因',
          starType: 'input',
          selectedOptionCode: '',
          selectedRateCode: '',
          styleType: 'sp',
          rateTexts: [
            { rateCode: '9-1', text: '1分-不喜欢' },
            { rateCode: '9-2', text: '2分-无所谓' },
            { rateCode: '9-3', text: '3分-喜欢' },
            { rateCode: '9-4', text: '4分-非常喜欢' }
          ]
        },
        {
          title: '购买博世技术件（如：高压喷油器，方向机，诊断仪等），扫一扫产品上的二维码，兑换免费视频/语音技术答疑',
          questionCode: '005-05-10',
          questionType: '03',
          rateValue: -1,
          i: 5,
          index: -1,
          content: '',
          tip: '请说明不满意的原因',
          starType: 'input',
          selectedOptionCode: '',
          selectedRateCode: '',
          styleType: 'sp',
          rateTexts: [
            { rateCode: '10-1', text: '1分-不喜欢' },
            { rateCode: '10-2', text: '2分-无所谓' },
            { rateCode: '10-3', text: '3分-喜欢' },
            { rateCode: '10-4', text: '4分-非常喜欢' }
          ]
        },
        {
          title: '免费查询博世汽车配件电子目录',
          questionCode: '005-05-11',
          questionType: '03',
          rateValue: -1,
          i: 5,
          index: -1,
          content: '',
          tip: '请说明不满意的原因',
          starType: 'input',
          selectedOptionCode: '',
          selectedRateCode: '',
          styleType: 'sp',
          rateTexts: [
            { rateCode: '11-1', text: '1分-不喜欢' },
            { rateCode: '11-2', text: '2分-无所谓' },
            { rateCode: '11-3', text: '3分-喜欢' },
            { rateCode: '11-4', text: '4分-非常喜欢' }
          ]
        },
        {
          title: '以低于市场价格，在易加网查询多品牌目录',
          questionCode: '005-05-12',
          questionType: '03',
          rateValue: -1,
          i: 5,
          index: -1,
          content: '',
          tip: '请说明不满意的原因',
          starType: 'input',
          selectedOptionCode: '',
          selectedRateCode: '',
          styleType: 'sp',
          rateTexts: [
            { rateCode: '12-1', text: '1分-不喜欢' },
            { rateCode: '12-2', text: '2分-无所谓' },
            { rateCode: '12-3', text: '3分-喜欢' },
            { rateCode: '12-4', text: '4分-非常喜欢' }
          ]
        },
        {
          title: '免费在易加网查询附近的博世经销商，发信息进行产品询价沟通',
          questionCode: '005-05-13',
          questionType: '03',
          i: 5,
          rateValue: -1,
          index: -1,
          content: '',
          tip: '请说明不满意的原因',
          starType: 'input',
          selectedOptionCode: '',
          selectedRateCode: '',
          styleType: 'sp',
          rateTexts: [
            { rateCode: '13-1', text: '1分-不喜欢' },
            { rateCode: '13-2', text: '2分-无所谓' },
            { rateCode: '13-3', text: '3分-喜欢' },
            { rateCode: '13-4', text: '4分-非常喜欢' }
          ]
        },
        {
          title: '维修站可以在易加网上传推广素材；使用易加网积分可以将宣传素材定向推荐给维修站附近的博世车主会员，帮助维修站引流',
          questionCode: '005-05-14',
          questionType: '03',
          rateValue: -1,
          i: 5,
          index: -1,
          content: '',
          tip: '请说明不满意的原因',
          starType: 'input',
          selectedOptionCode: '',
          selectedRateCode: '',
          styleType: 'sp',
          rateTexts: [
            { rateCode: '14-1', text: '1分-不喜欢' },
            { rateCode: '14-2', text: '2分-无所谓' },
            { rateCode: '14-3', text: '3分-喜欢' },
            { rateCode: '14-4', text: '4分-非常喜欢' }
          ]
        },
        {
          title: '维修站可以在易加网上传维修案例，其他维修站可以阅读该案例；阅读量高的案例会获得额外积分奖励',
          questionCode: '005-05-15',
          questionType: '03',
          rateValue: -1,
          i: 5,
          index: -1,
          content: '',
          tip: '请说明不满意的原因',
          starType: 'input',
          selectedOptionCode: '',
          selectedRateCode: '',
          styleType: 'sp',
          rateTexts: [
            { rateCode: '15-1', text: '1分-不喜欢' },
            { rateCode: '15-2', text: '2分-无所谓' },
            { rateCode: '15-3', text: '3分-喜欢' },
            { rateCode: '15-4', text: '4分-非常喜欢' }
          ]
        },
        {
          title: '可以在易加网上查看有意向到同城市工作的技师',
          questionCode: '005-05-16',
          questionType: '03',
          rateValue: -1,
          i: 5,
          index: -1,
          content: '',
          isFooter: true,
          tip: '请说明不满意的原因',
          starType: 'input',
          selectedOptionCode: '',
          selectedRateCode: '',
          styleType: 'sp',
          rateTexts: [
            { rateCode: '16-1', text: '1分-不喜欢' },
            { rateCode: '16-2', text: '2分-无所谓' },
            { rateCode: '16-3', text: '3分-喜欢' },
            { rateCode: '16-4', text: '4分-非常喜欢' }
          ]
        },
        {
          title: '您喜欢什么样的礼品品类（多选2种）',
          questionCode: '005-06',
          questionType: '02',
          starType: 'input',
          content: '',
          list: [],
          limit: 2,
          i: 6,
          questionAnswer: '',
          tip: '其它请注明',
          type: 'input',
          item: [
            { optionCode: '005-06-01', optionName: '工作服装' },
            { optionCode: '005-06-02', optionName: '维修站日常用品(如：手套，工具，清洁用品，文具）' },
            { optionCode: '005-06-03', optionName: '个人生活用品' },
            { optionCode: '005-06-04', optionName: '车上用品或者装饰品' },
            { optionCode: '005-06-05', optionName: '展架、产品宣传材料' },
            { optionCode: '005-06-05', optionName: '其他' }
          ]
        },
        {
          title: '您希望在易加网的公众号上阅读到什么样的信息',
          questionCode: '005-07',
          i: 7,
          questionType: '02',
          starType: 'input',
          content: '',
          list: [],
          questionAnswer: '',
          tip: '其它请注明',
          type: 'input',
          item: [
            { optionCode: '005-07-01', optionName: '基于车型的维修案例' },
            { optionCode: '005-07-02', optionName: '行业信息（如：汽车销量）' },
            { optionCode: '005-07-03', optionName: '专家维修直播' },
            { optionCode: '005-07-04', optionName: '易加网活动或者新上架的礼品' },
            { optionCode: '005-07-05', optionName: '博世新上市的产品' },
            { optionCode: '005-07-06', optionName: '其他' }
          ]
        },
        {
          title: '您对礼品到货时间的期待是多久?',
          questionCode: '005-08',
          questionType: '01',
          index: -1,
          i: 8,
          item: [
            { optionCode: '005-08-01', optionName: '3天以内' },
            { optionCode: '005-08-02', optionName: '3~5天' },
            { optionCode: '005-08-03', optionName: '一周以内' },
            { optionCode: '005-08-04', optionName: '两周以内' },
            { optionCode: '005-08-05', optionName: '一个月以内' }
          ]
        },
        {
          title: '以下技术资料，请按照您感兴趣的优先级，由高到低排序（排序题,请按优先级依次输入数字1-5)',
          questionCode: '005-09',
          i: 9,
          questionType: '02',
          isRank: true,
          list: [],
          item: [
            { optionCode: '005-09-01', optionName: '维修视频' },
            { optionCode: '005-09-02', optionName: '维修手册' },
            { optionCode: '005-09-03', optionName: '电路图' },
            { optionCode: '005-09-04', optionName: '正时图' },
            { optionCode: '005-09-05', optionName: '故障码解释' }
          ]
        },
        {
          title: '对于以上技术资料，如果能解决您90%以上的查询需求，您愿意支付多少年费',
          questionCode: '005-10',
          questionType: '01',
          index: -1,
          i: 10,
          item: [
            { optionCode: '005-10-01', optionName: '200元以内' },
            { optionCode: '005-10-02', optionName: '200~300元' },
            { optionCode: '005-10-03', optionName: '300~400元' },
            { optionCode: '005-10-04', optionName: '400~600元' },
            { optionCode: '005-10-05', optionName: '600~800元' }
          ]
        },
        {
          title: '对于每次通过汽修技术专家的视频/语音，获得维修思路的支持，您愿意支付价值多少的积分进行兑换？',
          questionCode: '005-11',
          questionType: '01',
          index: -1,
          i: 11,
          item: [
            { optionCode: '005-11-01', optionName: '免费' },
            { optionCode: '005-11-02', optionName: '10元' },
            { optionCode: '005-11-03', optionName: '10~20元' },
            { optionCode: '005-11-04', optionName: '20~30元' },
            { optionCode: '005-11-05', optionName: '30~50元' }
          ]
        },
        {
          title: '以下哪些功能，您希望可以在易加网公众号下面的菜单中可以直接进入',
          questionCode: '005-12',
          questionType: '02',
          starType: 'input',
          content: '',
          list: [],
          i: 12,
          questionAnswer: '',
          tip: '其它请注明',
          type: 'input',
          item: [
            { optionCode: '005-12-01', optionName: '积分商城' },
            { optionCode: '005-12-02', optionName: '产品扫码' },
            { optionCode: '005-12-03', optionName: '产品电子目录' },
            { optionCode: '005-12-04', optionName: '电子质保' },
            { optionCode: '005-12-05', optionName: '维修案例分享' },
            { optionCode: '005-12-06', optionName: '培训视频' },
            { optionCode: '005-12-07', optionName: '维修直播' },
            { optionCode: '005-12-08', optionName: '易加网活动' },
            { optionCode: '005-12-09', optionName: '在线视频/语音技术支持' },
            { optionCode: '005-12-10', optionName: '上传维修站活动或者视频触达附近博世车主会员' },
            { optionCode: '005-12-11', optionName: '查询附近的博世经销商，进行询价' },
            { optionCode: '005-12-12', optionName: '其他' }
          ]
        },
        {
          title: '是否可以联系您参加易加网升级改版后的测试及反馈？',
          questionCode: '005-13',
          questionType: '01',
          index: -1,
          i: 13,
          item: [
            { optionCode: '005-13-01', optionName: '是' },
            { optionCode: '005-13-02', optionName: '否' }

          ]
        }
      ],
      initList: [],
      rageScore: 1,
      // rateTexts: ['1分-不喜欢', '2分-无所谓', '3分-喜欢', '4分-非常喜欢', '5分', '6分', '7分', '8分', '9分', '10分'],
      userInfo: {},
      popShow: false,
      popShow2: false,
      popShow3: false,
      currentIndex: [],
      currentRadio: [],
      count: 0,
      rankObj: {}
    }
  },
  created () {
    this.init()
  },
  methods: {
    init () {
      this.initList = []
      this.resetForm(this.initList, this.optionList)

      this.userInfo = userUtils.getClientInfo()
      if (!this.userInfo) {
        this.$router.push({
          name: 'login',
          params: {
            redirectUrl: 'questionnaire'
          }
        })
      } else {
        if (!this.userInfo.isActivated) {
          window.location.href = commonUtils.getExtraSite() + '/#/activation_step_one'
          return
        }
        this.isCanJoin()
      }
    },
    isCanJoin () {
      const marketArr = ['IAM', 'OES']
      if (marketArr.indexOf(this.userInfo.marketName) === -1) {
        this.popShow3 = true
      } else {
        this.popShow3 = false
        this.isJoined()
      }
    },
    isJoined () {
      const questionnaireCode = '005'
      activityApi.isJoinedQuestionnaire(questionnaireCode).then(res => {
        if (res.data.resultCode === '0') {
          this.visitDate = res.data.resultData.visitDate
          if (res.data.resultData.questionnaireRecordList.length) {
            this.popShow2 = true
          } else {
            this.popShow2 = false
          }
        }
      })
    },
    typeText (type, isRank) {
      if (isRank) {
        return '排序'
      } else {
        switch (type) {
          case '01': return '单选'
          case '02': return '多选'
          case '03': return '单选'
        }
      }
    },

    /** 选择分数 */
    chooseScore (item, i, index) {
      this.currentIndex = []
      this.optionList[index].selectedRateCode = item.rateCode
      this.optionList.forEach(item => {
        if (item.selectedRateCode) {
          this.currentIndex.push(item.selectedRateCode)
        }
      })
      this.optionList[index].rateValue = i + 1
    },

    handleInputChange (e, index, i) {
      let value = e.target.value
      let arr = ['1', '2', '3', '4', '5']
      let arrList = []
      for (let item in this.rankObj) {
        // console.log(this.rankObj[i]);
        arrList.push(this.rankObj[item])
      }
      if (arr.indexOf(value) === -1 && value !== '') {
        Toast.fail(`请输入1~5间的数字`)
        this.optionList[index].item[i].value = ''
        this.rankObj[i] = ''
        arrList[i] = ''
      } else if (arrList.indexOf(value) !== -1 && value !== '') {
        Toast.fail('输入数字重复')
        this.optionList[index].item[i].value = ''
        this.rankObj[i] = ''
        arrList[i] = ''
        // e.target.value = ''
      } else if (value === '') {
        this.rankObj[i] = ''
        arrList[i] = ''
      } else {
        this.rankObj[i] = value
      }
    },

    handleSubmit () {
      const params = {
        questionnaireCode: '005',
        clientCode: this.clientCode,
        questionnaireList: []
      }
      console.log(this.optionList)
      let flag = false
      for (let j = 0; j < this.optionList.length; j++) {
        // 单选
        if (this.optionList[j].questionType === '01' && !this.optionList[j].starType) {
          if (this.optionList[j].index < 0) {
            Toast.fail(`第${this.optionList[j].i}题必填`)
            flag = true
            break
          }
          params.questionnaireList.push({
            questionCode: this.optionList[j].questionCode,
            questionType: this.optionList[j].questionType,
            optionCode: this.optionList[j].item[this.optionList[j].index].optionCode,
            optionName: this.optionList[j].item[this.optionList[j].index].optionName,
            questionAnswer: this.optionList[j].item[this.optionList[j].index].optionName,
            optionDesc: ''
          })
        }

        // 单选中有文本框
        if (this.optionList[j].questionType === '01' && this.optionList[j].starType === 'input') {
          if (this.optionList[j].index < 0 || (this.optionList[j].index === this.optionList[j].item.length && !this.optionList[j].content)) {
            Toast.fail(`第${this.optionList[j].i}题必填`)
            flag = true
            break
          }
          // 如果选择单选框
          if (this.optionList[j].index >= 0 && !this.optionList[j].content) {
            params.questionnaireList.push({
              questionCode: this.optionList[j].questionCode,
              questionType: this.optionList[j].questionType,
              optionCode: this.optionList[j].item[this.optionList[j].index].optionCode,
              optionName: this.optionList[j].item[this.optionList[j].index].optionName,
              questionAnswer: this.optionList[j].item[this.optionList[j].index].optionName,
              optionDesc: ''
            })
          }
          // 如果选择填写文本框
          if (this.optionList[j].content) {
            params.questionnaireList.push({
              questionCode: this.optionList[j].questionCode,
              questionType: this.optionList[j].questionType,
              optionCode: this.optionList[j].item[this.optionList[j].item.length - 1].optionCode,
              optionName: this.optionList[j].item[this.optionList[j].item.length - 1].optionName,
              questionAnswer: this.optionList[j].item[this.optionList[j].item.length - 1].optionName,
              optionDesc: this.optionList[j].content
            })
          }
        }

        // 多选
        if (this.optionList[j].questionType === '02') {
          // 排序
          if (this.optionList[j].limit && this.optionList[j].list.length > this.optionList[j].limit) {
            Toast.fail(`第6题最多选择2项`)
            flag = true
            break
          }
          if (this.optionList[j].isRank) {
            // console.log(this.optionList[j])
            for (let i of this.optionList[j].item) {
              if (!i.value) {
                Toast.fail(`第${this.optionList[j].i}题必填`)
                flag = true
                break
              }
            }
            this.optionList[j].item.forEach(i => {
              params.questionnaireList.push({
                questionCode: this.optionList[j].questionCode,
                questionType: this.optionList[j].questionType,
                optionCode: i.optionCode,
                optionName: i.optionName,
                questionAnswer: i.value,
                optionDesc: ''
              })
            })
          } else if (this.optionList[j].type === 'input') {
            console.log(this.optionList[j].questionAnswer)
            console.log(this.optionList[j].list.length)

            if (!this.optionList[j].list.length) {
              Toast.fail(`第${this.optionList[j].i}题必填`)
              flag = true
              break
            }

            // if ((this.optionList[j].list.indexOf(this.optionList[j].item.length - 1) !== -1 && this.optionList[j].questionAnswer === '')) {
            //   Toast.fail(`第${this.optionList[j].i}题必填`)
            //   flag = true
            //   break
            // }
            this.optionList[j].list.forEach(i => {
              if (this.optionList[j].list.indexOf(this.optionList[j].item.length - 1) !== -1 && i === this.optionList[j].item.length - 1) {
                params.questionnaireList.push({
                  questionCode: this.optionList[j].questionCode,
                  questionType: this.optionList[j].questionType,
                  optionCode: this.optionList[j].item[this.optionList[j].item.length - 1].optionCode,
                  optionName: this.optionList[j].item[this.optionList[j].item.length - 1].optionName,
                  questionAnswer: this.optionList[j].item[this.optionList[j].item.length - 1].questionAnswer,
                  optionDesc: this.optionList[j].questionAnswer
                })
              } else {
                params.questionnaireList.push({
                  questionCode: this.optionList[j].questionCode,
                  questionType: this.optionList[j].questionType,
                  optionCode: this.optionList[j].item[i].optionCode,
                  optionName: this.optionList[j].item[i].optionName,
                  questionAnswer: this.optionList[j].item[i].optionName,
                  optionDesc: ''
                })
              }
            })
          } else {
            if (!this.optionList[j].list.length) {
              Toast.fail(`第${this.optionList[j].i}题必填`)
              flag = true
              break
            }
            console.log(this.optionList[j])
            if (this.optionList[j].limit && this.optionList[j].list.length > this.optionList[j].limit) {
              Toast.fail(`第6题最多选择2项`)
              flag = true
              break
            }
            this.optionList[j].list.forEach(i => {
              params.questionnaireList.push({
                questionCode: this.optionList[j].questionCode,
                questionType: this.optionList[j].questionType,
                optionCode: this.optionList[j].item[i].optionCode,
                optionName: this.optionList[j].item[i].optionName,
                questionAnswer: this.optionList[j].item[i].optionName,
                optionDesc: ''
              })
            })
          }
        }

        // 问答
        if (this.optionList[j].questionType === '04' && !this.optionList[j].isRank) {
          if (this.optionList[j].questionAdvice === '') {
            Toast.fail(`第${this.optionList[j].i}题必填`)
            flag = true
            break
          }
          params.questionnaireList.push({
            questionCode: this.optionList[j].questionCode,
            questionType: this.optionList[j].questionType,
            optionCode: this.optionList[j].optionCode,
            optionName: this.optionList[j].tip,
            questionAnswer: this.optionList[j].questionAdvice,
            optionDesc: ''
          })
        }

        // 排序
        // if (this.optionList[j].questionType === '04' && this.optionList[j].isRank) {
        //   if (this.count !== 5) {
        //     Toast.fail(`第${this.optionList[j].i}题必填`)
        //     flag = true
        //     break
        //   }
        //   params.questionnaireList.push({
        //     questionCode: this.optionList[j].questionCode,
        //     questionType: this.optionList[j].questionType,
        //     optionCode: this.optionList[j].optionCode,
        //     optionName: this.optionList[j].order,
        //     questionAnswer: this.optionList[j].order,
        //     optionDesc: ''
        //   })
        // }

        // 评分 满分10分
        if (this.optionList[j].questionType === '03' && !this.optionList[j].rateStar) {
          if (!this.optionList[j].rateValue) {
            Toast.fail(`第${this.optionList[j].i}题必填`)
            flag = true
            break
          }
          // 只有评分没有选项
          if (this.optionList[j].rateValue > this.rageScore || this.optionList[j].isSlider) {
            params.questionnaireList.push({
              questionCode: this.optionList[j].questionCode,
              questionType: this.optionList[j].questionType,
              optionCode: '',
              optionName: '',
              questionAnswer: this.optionList[j].rateValue,
              optionDesc: ''
            })
          }

          if (this.optionList[j].rateValue <= this.rageScore && !this.optionList[j].isSlider) {
            // 全是单选
            if (this.optionList[j].starType === 'radio') {
              if (this.optionList[j].index < 0) {
                Toast.fail(`第${this.optionList[j].i}题必填`)
                flag = true
                break
              }
              params.questionnaireList.push({
                questionCode: this.optionList[j].questionCode,
                questionType: this.optionList[j].questionType,
                optionCode: this.optionList[j].item[this.optionList[j].index].optionCode,
                optionName: this.optionList[j].item[this.optionList[j].index].optionName,
                questionAnswer: this.optionList[j].rateValue,
                optionDesc: ''
              })
            }

            // 单选加文本
            if (this.optionList[j].starType === 'input' && this.optionList[j].item) {
              if (this.optionList[j].index < 0) {
                Toast.fail(`第${this.optionList[j].i}题必填`)
                flag = true
                break
              }
              // 如果选择单选框
              if (this.optionList[j].index >= 0 && !this.optionList[j].content) {
                params.questionnaireList.push({
                  questionCode: this.optionList[j].questionCode,
                  questionType: this.optionList[j].questionType,
                  optionCode: this.optionList[j].item[this.optionList[j].index].optionCode,
                  optionName: this.optionList[j].item[this.optionList[j].index].optionName,
                  questionAnswer: this.optionList[j].rateValue,
                  optionDesc: ''
                })
              }
              // 如果选择填写文本框
              if (this.optionList[j].content) {
                params.questionnaireList.push({
                  questionCode: this.optionList[j].questionCode,
                  questionType: this.optionList[j].questionType,
                  optionCode: this.optionList[j].item[this.optionList[j].item.length - 1].optionCode,
                  optionName: this.optionList[j].item[this.optionList[j].item.length - 1].optionName,
                  questionAnswer: this.optionList[j].rateValue,
                  optionDesc: this.optionList[j].content
                })
              }
            }

            // 纯文本
            if (this.optionList[j].starType === 'input' && !this.optionList[j].item) {
              if (!this.optionList[j].content && this.optionList[j].i) {
                Toast.fail(`第${this.optionList[j].i}题必填`)
                flag = true
                break
              }
              params.questionnaireList.push({
                questionCode: this.optionList[j].questionCode,
                questionType: this.optionList[j].questionType,
                optionCode: this.optionList[j].optionCode,
                optionName: this.optionList[j].tip,
                questionAnswer: this.optionList[j].rateValue,
                optionDesc: this.optionList[j].content
              })
            }
          }
        }
        // 评分 满分5分
        if (this.optionList[j].questionType === '03' && this.optionList[j].rateStar && !this.optionList[j].isSlider) {
          if (this.optionList[j].rateValue === 0) {
            Toast.fail(`第${this.optionList[j].i}题必填`)
            flag = true
            break
          }
          params.questionnaireList.push({
            questionCode: this.optionList[j].questionCode,
            questionType: this.optionList[j].questionType,
            optionCode: '',
            optionName: '',
            questionAnswer: this.optionList[j].rateValue,
            optionDesc: ''
          })
        }
        // 评分 滑块
        // if (this.optionList[j].questionType === '03' && !this.optionList[j].rateStar && this.optionList[j].isSlider) {
        //   console.log(111)
        //   if (this.optionList[j].rateValue === 0) {
        //     Toast.fail(`第${this.optionList[j].i}题必填`)
        //     flag = true
        //     break
        //   }
        //   params.questionnaireList.push({
        //     questionCode: this.optionList[j].questionCode,
        //     questionType: this.optionList[j].questionType,
        //     optionCode: '',
        //     optionName: '',
        //     questionAnswer: this.optionList[j].rateValue,
        //     optionDesc: ''
        //   })
        // }
      }
      if (flag) {
        return
      }
      let count = 0
      for (let item of params.questionnaireList) {
        if (item.questionAnswer && item.questionAnswer === 4) {
          count++
        }
      }
      if (count > 5) {
        Toast.fail(`第5题非常喜欢不能超过5条`)
        flag = true
        return
      }
      console.log(params)
      params.visitDate = this.visitDate
      this.loading = true
      activityApi.submitQuestionnaire(params).then(response => {
        if (response.data.resultCode === '0') {
          this.popShow = true
          this.clientCode = ''
        } else {
          Toast.fail(response.data.resultMsg)
        }
        this.loading = false
      }).catch(() => {
        this.loading = false
      })
    },
    resetForm (initArr, optionArr) {
      optionArr.forEach(option => {
        const obj = Object.assign({}, option)
        initArr.push(obj)
      })
    },
    handleRateChange (option) {
      if (option.questionAnswer > this.rageScore - 1) {
        option.index = -1
        option.content = ''
      }
    },
    popJump () {
      window.location.href = commonUtils.getExtraSite() + '/#/tab/home'
    },
    // 排序
    // handleRank (option, item) {
    //   this.count = 0
    //   item.choosed = !item.choosed
    //   for (let i of option.item) {
    //     if (i.choosed) {
    //       this.count += 1
    //     }
    //   }
    //   if (item.choosed) {
    //     this.$set(item, 'rank', this.count)
    //   } else {
    //     if (item.rank !== (this.count + 1)) {
    //       for (let i of option.item) {
    //         if (i.rank) {
    //           this.$delete(i, 'rank')
    //           this.$delete(i, 'choosed')
    //         }
    //       }
    //     } else {
    //       this.$delete(item, 'rank')
    //     }
    //   }

    //   if (this.count === 5) {
    //     for (let i of option.item) {
    //       option.order += i.rank
    //     }
    //   }
    // },
    onChange (value) {
      Toast('当前值：' + value)
    }
  }
}
</script>

<style lang="less" scoped>
.page {
  padding-top: 0;
  background: #fff;
  /deep/ .van-radio__icon--checked {
    .van-icon {
      border-color: #117281;
      background-color: #117281;
    }
  }
  /deep/ .van-checkbox__icon--checked {
    .van-icon {
      border-color: #117281;
      background-color: #117281;
    }
  }
  /deep/ .van-radio__label {
    color: #333;
  }

    /deep/ .van-rate__item {
    i {
      color: #117281 !important;
    }
  }
  img {
    width: 100%;
  }
}
.title-icon {
  position: relative;
  width: 12%;
  text-align: center;
  span {
    display: inline-block;
    position: absolute;
    top: 50%;
    left: 50%;
    transform: translate(-50%, -50%);
    color: #ffffff;
  }
}
.content {
  padding: 15px;
  background: #f1f1f1;
  .bar_title {
    display: flex;
    .title {
      position: relative;
      flex: 1;
      padding-left: 10px;
      vertical-align: middle;
      span {
        position: absolute;
        top: 50%;
        transform: translateY(-50%);
      }
    }
    .questionType {
      width: 15%;
      padding: 10px;
      line-height: 1.5;
      text-align: center;
      color: #247181;
    }
  }
  .van-radio {
    display: inline-flex;
    padding: 0 10px 8px 0;
  }
  .van-checkbox {
    display: inline-flex;
    padding: 0 10px 8px 0;
  }
  .content_title {
    margin: 10px 0;
  }
}
.submit-btn {
  padding: 14px 0 24px;
  text-align: center;
  .van-button {
    width: 200px;
    height: 40px;
    line-height: 40px;
    background: #117281;
    border: none;
  }
}
.msg-pop {
  width: 200px;
  height: 135px;
  border-radius: 10px;
  text-align: center;
  box-sizing: border-box;
  padding: 8px;
  .msg-text {
    font-size: 14px;
    margin-top: 10px;
    color: #402d26;
    line-height: 22px;
  }
  .msg-btn {
    margin: auto;
    margin-top: 8px;
    width: 90px;
    height: 35px;
    border-radius: 8px;
    line-height: 35px;
    font-size: 14px;
  }
}
.msg-pop-join {
  height: 110px;
}
.msg-pop-error {
  width: 220px;
  height: 110px;
}
.score-content {
  display: flex;
  //justify-content: space-between;
  padding: 10px 10px;
}
.score {
  display: inline-block;
  //idth: 9%;
  text-align: center;
  line-height: 40px;
  font-size: 12px;
  background: #f1f1f1;
  border: 1px solid #cccccc;
  cursor: pointer;
  margin-left: 10px;
  padding: 0 3px;
}
.select {
  background-image: linear-gradient(#3b8c96, #23565d);
  color: #ffffff;
}
.content_title {
  padding: 0 15px;
}
.low-score {
  padding: 0 10px 10px 10px;
}
.score-field .van-field {
  background: #f1f1f1;
  border-radius: 5px;
}
.van-radio-box {
  display: flex;
  flex-wrap: wrap;
  justify-content: space-between;
  box-sizing: border-box;
  font-size: 12px;
}
.van-radio {
  position: relative;
  width: 100%;
  margin-bottom: 10px;
}
.bg-radio-box {
  position: absolute;
  width: 158px;
  top: 50%;
  left: 50%;
  transform: translate(-50%,-50%);
  padding-left: 45px;
}
.van-radio-box .van-radio {
  width: 158px;
  padding: 0;
  border: 1px solid #f5f5f5;
}
.van-radio .van-radio__label {
  margin-left: 0px;
}
.radio {
  position: relative;
  height: 20px;
  margin-bottom: 10px;
  background: #f7f7f7;
}
.radio-input {
  background: #f7f7f7;
  .van-radio__icon {
    display: none;
  }
}
.field-input {
  width: 100%;
  font-size: 12px;
  background: #f7f7f7;
  padding: 0px 0px 10px 0px;
}
</style>
<style>
.full-radio .van-radio__label {
  flex: 1;
}
.full-radio .van-cell {
  background: #f1f1f1;
  border-radius: 5px;
}
.van-radio .van-radio__icon {
  z-index: 10;
}
.radio-input .van-radio__icon {
  display: none;
}
.van-radio__icon--checked + .van-radio__label > .bg-radio-box{
  background-image: linear-gradient(#3b8c96, #23565d);;
  color: #fff;
}
.van-radio__icon--checked .van-icon {
  border-color: #ffffff !important;
}
.field-input .van-field__control,
.score-field .van-field__control {
  height: auto !important;
}

.rate-score {
    margin-bottom: 8px;
    padding: 20px 20px;
  }
.rate-evaluation {
    position: relative;
    top: -4px;
    right: 0vw;
    color: #117281;
  }
  .rank{
    height: 50px;
    line-height: 30px;
  }
  .optionName{
    position: absolute;
    top: 2.5px;
    display: inline-block;
    left: 15px;
  }
  .rank-box{
    display: inline-block;
    position:absolute;
    top: 5px;
    width: 18px;
    height: 18px;
    border: 1px solid rgb(196, 196, 196);
    text-align: center;
    line-height: 18px;
  }
  .slider{
    height: 50px;
    margin:20px ;
  }
  .van-slider__bar{
    background-color: #117281;
  }
  .slider-text{
    font-size: 12px;
    margin-top: 15px;
    display: flex;
    justify-content: space-between;
  }
  .rank-input{
    position: absolute;
    top: -5px;
    left: 72vw;
    display: inline-block;
  }
  .rank-input .van-cell{
    display: inline-block;
    padding: 0;
    width: 15px;
    position: relative;
    top: 7px;
  }
  .box{
    background-color:#ffffff;
    margin-bottom:15px;
    border-radius:2px
  }
  .box-sp{
    background-color:#ffffff;
    border-radius:2px
  }
  .item-title{
    padding-left: 10px;
  }
  .header-info1{
    padding: 20px 10px 10px 10px;
    line-height: 20px;
    font-size: 16px;
  }
  .header-info2{
    padding: 5px 10px;
    line-height: 20px;
    font-size: 14px;
  }
</style>
